import { Observable } from "rxjs";
import * as http from "../../../../../services/http.service";
import { BriefProductForm } from "../../../../../features/products/types/brief-product-form/brief-product-form.interface";
import { IBriefProduct } from "../../../../../types/product/ibrief-product/ibrief-product.interface";
import { SearchResults } from "../../../../../types/search/search-results.interface";

function endPoint(id: number): string {
  return `/work-orders/${id}/products/`;
}

export function workOrderProductsFileDownloadEndPoint(workOrderId: number): string {
  return `work-orders/${workOrderId}/product-download/`;
}

function mapProductToPost(product: number) {
  return {
    product,
    buy_get_status: 2,
    future_price: undefined,
  };
}

function mapProductsToPatch(products: BriefProductForm[]): any {
  return products.map(mapProductToPatch);
}

function mapProductToPatch(product: BriefProductForm): any {
  const { positionText, relatedGetProductIds, ...rest } = product;
  return {
    ...rest,
    position_description: positionText,
    related_get_products: relatedGetProductIds,
  };
}

export function addProduct(product: number, workOrderId: number): Observable<IBriefProduct> {
  return http.post(endPoint(workOrderId), mapProductToPost(product));
}

export function fetchProducts(workOrderId: number): Observable<SearchResults<IBriefProduct>> {
  return http.get(endPoint(workOrderId));
}

export function updateProducts(
  products: BriefProductForm[],
  workOrderId: number
): Observable<{ products: IBriefProduct[] }> {
  return http.patch(endPoint(workOrderId), { products: mapProductsToPatch(products) });
}
